import config from "src/config";
import { ResponseDto } from 'src/dtos/common/responseDto';
import { deleteData, getData, patchData, postData } from 'src/utils/axios/serverHelper';
import { EQM2010_R01HeaderDto, EQM2010_R01DetailDto } from 'src/containers/mes/EQM/EQM2010_R01/Dto_EQM2010_R01';
import { EQM2010_R01Filter } from 'src/containers/mes/EQM/EQM2010_R01/Store_EQM2010_R01';

const baseUrl = `${config.apiUrl}/EQM2010_R01`;

export const getEQM2010_R01List = async (option: string, params: Partial<EQM2010_R01Filter>, listLength: number = 0) => {
	const url = `${baseUrl}/${option}`
	return await getData<ResponseDto<EQM2010_R01HeaderDto[]>>(url, {
		params: {
			...params,
			listLength
		}
	});
}

export const getEQM2010_R01AllCount = async (params: Partial<EQM2010_R01Filter>) => {
	const url = `${baseUrl}/allCount`;
	return await getData<ResponseDto<number>>(url, {
		params: {
			...params
		}
	});
}

export const getEQM2010_R01DetailList = async (equipmentCd: string) => {
	const url = `${baseUrl}/detail/${equipmentCd}`;
	return await getData<ResponseDto<EQM2010_R01DetailDto[]>>(url);
}

// 설비유형별 모든 점검항목 + 계획여부(planYn) 포함 조회
export const getEQM2010_R01DetailListWithPlan = async (equipmentCd: string) => {
	const url = `${baseUrl}/detail-with-plan/${equipmentCd}`;
	return await getData<ResponseDto<EQM2010_R01DetailDto[]>>(url);
}

//  설비정보 생성
// 서버는 List<EQM2010_R01Dto> 내 eqm2010_R01DetailDtoList를 기대
type EQM2010_R01OuterDto = { eqm2010_R01DetailDtoList: EQM2010_R01DetailDto[] };

export const createEQM2010_R01 = async (dtoList: EQM2010_R01DetailDto[]) => {
	const url = `${baseUrl}`;
	const body: EQM2010_R01OuterDto[] = [{ eqm2010_R01DetailDtoList: dtoList }];
	return await postData<EQM2010_R01OuterDto[], ResponseDto<void>>(url, body);
}

//  설비정보 수정
export const updateEQM2010_R01 = async (dtoList: EQM2010_R01DetailDto[]) => {
	const url = `${baseUrl}`;
	const body: EQM2010_R01OuterDto[] = [{ eqm2010_R01DetailDtoList: dtoList }];
	return await patchData<EQM2010_R01OuterDto[], ResponseDto<void>>(url, body);
}

// 점검계획 삭제
export const deleteEQM2010_R01 = async (equipmentCd: string, inspectCdCsv?: string) => {
	const url = `${baseUrl}`;
	return await deleteData<ResponseDto<void>>(url, {
		params: {
			equipmentCd,
			inspectCd: inspectCdCsv
		}
	});
}

// 엑셀 다운로드 (GET)
export const downloadExcel_EQM2010_R01 = async (option: string, params: Partial<EQM2010_R01Filter>, listLength: number = 0) => {
    const url = option ? `${baseUrl}/excel/${option}` : `${baseUrl}/excel`;
    return await getData<ResponseDto<string>>(url, {
        params: {
            ...params,
            listLength
        }
    });
}